import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  lazy,
  Suspense,
} from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { Grid, Container, Box, Dialog, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import InView from "../misc/InView";
//import { Pagination } from "@material-ui/lab";
import { EqualHeight } from "react-equal-height";
import LoadingSection from "./parts/LoadingSection";
import PlayCard from "./cards/PlayCard";
import VideoCard from "./cards/VideoCard";
import { Markup } from "interweave";

//const AirplayPromoModule = lazy(() =>
// import(
//   /* webpackChunkName: 'apprmdl' */ "../airplay/airplay_promo_module.js.jsx"
// )
//);

const AirplayArtistPage = lazy(() =>
  import(/* webpackChunkName: 'aapg' */ "./AirplayArtistPage")
);

//import videoImage from "../assets/images/billieeilishvideo.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";
import { v4 as uuidv4 } from "uuid";
import { tunein } from "lib/player_util";
import { getJSON } from "lib/ajax";

const ArtistPage = observer(() => {
  useEffect(() => {
    console.log("ArtistPage onMount");
    return () => {
      console.log("ArtistPage onUnmount");
    };
  }, []);

  // console.log("AP", match);
  const store = useContext(playerStoreContext);

  const { pathname } = useLocation();
  // artist from /music/:artist Route
  const { feature, artist: pageArtist } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const getArtistProfile = (dest) => {
    //const { pathname, search } = window.location;
    getJSON({ url: dest }).then((data) => {
      //    console.log("got artist data", data);
      setData(data);
      setLoading(false);
      store.setAirplayUX(Boolean(data.airplay));

      //   window.Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier(
      //     dest,
      //     window.Turbolinks.uuid()
      //   );
      // });
      // if (data.bioPath == pathname) {
      //   getBio();
      // }
    });
  };

  const {
    firstLoad,
    songInfo: { music_path, station_id }, // music_path is now playing artist path
  } = store;

  useEffect(() => {
    // console.log(
    //   "ArtistPage useEffect1",
    //   artist,
    //   pageArtist,
    //   data.artistName,
    //   pathname,
    //   music_path
    // );

    if (pathname == data?.musicPath) {
      // still re-renders
      return;
    }

    // next song re-renders -- on full_bio page this re-pops the bio dialog
    // if (
    //   data?.bioPath == pathname &&
    //   fullBio?.artistId &&
    //   data?.artistId &&
    //   fullBio?.artistId == data?.artistId
    // ) {
    //   return;
    // }

    // can be on '/' for firstLoad
    // pageArtist is subject of music/:artist

    const profile_data = document.querySelector("#artist_profile_data")?.dataset
      ?.data;
    if (profile_data) {
      document.querySelector("#artist_profile_data").remove();
    }
    if (profile_data && (pageArtist || firstLoad)) {
      console.log("ArtistPage data from html");
      const jdata = JSON.parse(profile_data);
      setData(jdata);
      setLoading(false);
      store.setAirplayUX(Boolean(jdata.airplay));

      // if (jdata?.bioPath == pathname) {
      //   getBio();
      // }
    } else {
      if (feature || pathname.indexOf("_full_bio") >= 0) {
        return;
      }
      console.log("ArtistPage data from json");

      // Now playing  i.e. "/"
      // when not firstLoad i.e. profile_data will not match currently playing artist because html doc has not rerendered
      getArtistProfile(pathname == "/" ? music_path : pathname);
    }
  }, [pathname, pageArtist, music_path]);

  // useEffect(() => {
  //   console.log("SHOULD UPDATE", music_path, now_playing_artist);
  // }, [music_path]);

  if (loading) {
    return <LoadingSection type="loading-page" />;
  }

  //console.log("AP", data);

  // some music gets played by artists that are not in the ASI
  if (!data.artistName) {
    console.log("AP data.artistName blank returning empty:", data.artistName);
    return "";
  }

  return (
    <Fragment>
      {data.airplay ? (
        <Suspense fallback={<LoadingSection type="loading-page" />}>
          <AirplayArtistPage
            key={`aap:${data.artistId}`}
            data={data}
            pathname={pathname}
          />
        </Suspense>
      ) : (
        <EstablishedArtistPage
          data={data}
          station_id={station_id}
          pathname={pathname}
        />
      )}
    </Fragment>
  );
});

const EstablishedArtistPage = ({ data, station_id, pathname }) => {
  const [fullBio, setFullBio] = useState(null);
  const [fullBioOpen, setFullBioOpen] = useState(false);

  const theme = useTheme();
  const fullScreenDialog = useMediaQuery(theme.breakpoints.down("sm"));

  const closeFullBio = () => {
    setFullBioOpen(false);
  };

  const getBio = (_e) => {
    setFullBioOpen(true);
    if (
      fullBio?.artistId &&
      data?.artistId &&
      fullBio?.artistId == data?.artistId
    ) {
      return;
    }

    getJSON({ url: pathname, data: { bio_only: 1 } }).then((data) => {
      //{artistId, bio}
      setFullBio(data);
    });
  };
  useEffect(() => {
    //console.log("Artistpage useEffect2");
    if (pathname == data?.bioPath) {
      getBio();
    }
  }, [pathname, data.bioPath]);

  const tuneinStation = () => {
    tunein(data.stationId);
  };

  return (
    <div id="artist-page">
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={3} id="artist-image">
            <InView>
              <img
                src={data.artistDefaultImage}
                srcSet={data.srcset}
                className="main-image"
              />
              <h1>{data.artistName}</h1>
              {station_id == data.stationId ? (
                <Link to="/" className="button bumpy">
                  Currently Playing
                </Link>
              ) : (
                <button className="bumpy" onClick={tuneinStation}>
                  Play Now &nbsp;
                  <FontAwesomeIcon icon="play-circle" />
                </button>
              )}
            </InView>
          </Grid>
          <Grid item xs={12} md className="pl-md-5">
            {data?.stations?.length > 0 && (
              <ArtistStations
                artistName={data.artistName}
                stations={data.stations}
              />
            )}

            {data?.artistBio?.length > 0 && (
              <Fragment>
                {" "}
                <h2 className="pt-5">Biography</h2>
                <p>
                  <Markup
                    content={data.artistBio.replace(
                      "&hellip;",
                      String.fromCharCode(8230)
                    )}
                  />{" "}
                  {data.bioPath == pathname ? (
                    <span className="click-underline" onClick={getBio}>
                      Read More
                    </span>
                  ) : (
                    <Link
                      style={{ color: "#000" }}
                      to={data.bioPath}
                      className="click-underline"
                    >
                      Read More
                    </Link>
                  )}{" "}
                </p>
              </Fragment>
            )}

            {data?.similars?.length > 0 && (
              <ArtistSimilars similars={data.similars} />
            )}

            {data?.songs?.length > 0 && (
              <ArtistSongs artistName={data.artistName} songs={data.songs} />
            )}
          </Grid>
        </Grid>

        <Dialog
          open={fullBioOpen}
          fullScreen={fullScreenDialog}
          onClose={closeFullBio}
        >
          <Box className="jango-modal">
            <div
              className="close-modal"
              style={{
                color: fullScreenDialog ? "black" : "white",
                position: "fixed",
                right: "1rem",
                top: "1rem",
              }}
            >
              <FontAwesomeIcon
                icon="times"
                className="icon-action"
                onClick={closeFullBio}
              />
            </div>
            <h2>Artist Bio</h2>
            {fullBio?.bio ? (
              <p>
                <Markup content={fullBio.bio} />
              </p>
            ) : (
              <LoadingSection type="loading-section" />
            )}
          </Box>
        </Dialog>
      </Container>
    </div>
  );
};

const ArtistStations = ({ artistName, stations }) => {
  return (
    <InView>
      <h2>Top Stations</h2>
      <p>All prominently featuring songs by {artistName}</p>

      <EqualHeight>
        <Grid container className="card-container pt-2" spacing={2}>
          {stations.map(({ id, _playPath, name, image }) => {
            return (
              <Grid key={uuidv4()} item xs={6} md={3}>
                <PlayCard title={name} image={image} station_id={id} />
              </Grid>
            );
          })}
        </Grid>
      </EqualHeight>
    </InView>
  );
};
const ArtistSimilars = ({ similars }) => {
  return (
    <InView>
      <h2 className="pt-5">Related Artists</h2>

      <EqualHeight>
        <Grid container className="card-container pt-3" spacing={2}>
          {similars.map(
            ({
              musicPath,
              artistDefaultImage,
              artistName,
              _artistId,
              station_id,
            }) => {
              return (
                <Grid key={uuidv4()} item xs={6} md={3} lg={2}>
                  <PlayCard
                    title={artistName}
                    image={artistDefaultImage}
                    musicPath={musicPath}
                    station_id={station_id}
                  />
                </Grid>
              );
            }
          )}
        </Grid>
      </EqualHeight>
    </InView>
  );
};
const ArtistSongs = ({ artistName, songs }) => {
  return (
    <InView>
      <h2 className="pt-5">Top Songs</h2>
      <EqualHeight>
        <Grid container className="card-container pt-3 pb-2" spacing={2}>
          {songs.map(
            ({
              id,
              name,
              favorite,
              video: { image = null, youtubeId = null } = {},
            }) => {
              return (
                <Grid key={uuidv4()} item xs={12} md={6}>
                  <VideoCard
                    song_id={id}
                    artist={artistName}
                    title={name}
                    image={image}
                    youtubeId={youtubeId}
                    favorite={favorite}
                  />
                </Grid>
              );
            }
          )}
        </Grid>
      </EqualHeight>
    </InView>
  );
};
//ArtistPage.whyDidYouRender = true;

export default ArtistPage;
